import { Controller } from "@hotwired/stimulus"

// Step 1 of a campaign (holiday dollar-a-day U6, R5, R5a): the big figure
// follows the amount picked, and the location tap closes Gold, Stocks and
// every stock under "See more", and picks Crypto. Unticking it opens them
// again and puts back the asset picked before the tick, or the first card
// (Gold, unless step 1 left it off) if there was none; a stock put back under a closed "See more" opens it, so the pick
// is never out of sight.
// The server renders the same state for a refused post and validates
// everything again on its own; this only keeps the page honest as it moves.
export default class extends Controller {
  static targets = ["amount", "figure", "asset", "location", "locationNote"]

  connect() {
    this.beforeTick = null
    this.refresh()
  }

  refresh() {
    const picked = this.amountTargets.find((radio) => radio.checked)
    if (this.hasFigureTarget) this.figureTarget.textContent = picked?.value || "?"
  }

  // The tap itself, on the checkbox's change. The radios' own changes go
  // through refresh only, so a tick is never undone by them.
  location() {
    const closed = this.locationTarget.checked
    if (closed) this.beforeTick = this.checkedAsset()
    for (const radio of this.assetTargets) {
      if (radio.value === "crypto") continue
      radio.disabled = closed
    }
    if (closed) {
      this.pick("crypto")
    } else {
      this.pick(this.beforeTick || this.firstOffered())
      this.beforeTick = null
    }
    this.locationNoteTargets.forEach((note) => { note.hidden = !closed })
  }

  // The first card on the page, as the server picks it: Gold, unless the
  // liquidity check left it off step 1 (2026-10-31).
  firstOffered() {
    return this.assetTargets[0]?.value || null
  }

  checkedAsset() {
    return this.assetTargets.find((radio) => radio.checked)?.value || null
  }

  pick(value) {
    const radio = this.assetTargets.find((target) => target.value === value)
    if (!radio) return
    radio.checked = true
    const more = radio.closest("details")
    if (more) more.open = true
  }
}
